<template>
  <div>
    <el-card shadow="hover">
      <template slot="header">
        <div class="clearfix">
          <span>客户提示</span>
          <el-button size="small" type="primary" plain icon="el-icon-refresh" @click="getAlertList" style="float:right">刷新</el-button>
        </div>
      </template>
      <div class="hint">
        <div><strong>尊贵卡A（提货间隔规则）</strong>：以提货申请时间为准（未提货取合同起始日），超期进入缓冲期/休眠，持续提货永不休眠；本页支持点击【解禁】恢复激活。</div>
        <div style="margin-top: 4px;"><strong>尊贵卡B/C（服务费规则）</strong>：按每年服务费到期及缓冲期判定，不支持解禁，须在销售订单完成缴费/续费后自动解除。</div>
      </div>
      <el-form :inline="true" :model="searchForm" class="mb-4">
        <el-form-item label="客户姓名">
          <el-input v-model="searchForm.customerName" placeholder="请输入" style="width: 180px" clearable @keyup.enter.native="handleSearch" @clear="handleSearch"></el-input>
        </el-form-item>
        <el-form-item label="提示类型">
          <el-select v-model="searchForm.alertType" clearable filterable placeholder="全部" style="width: 220px" @change="handleSearch" @clear="handleSearch">
            <el-option label="尊贵卡A到期提醒" value="尊贵卡A到期提醒"></el-option>
            <el-option label="尊贵卡A到期休眠" value="尊贵卡A到期休眠"></el-option>
            <el-option label="尊贵卡B到期提醒" value="尊贵卡B到期提醒"></el-option>
            <el-option label="尊贵卡C到期提醒" value="尊贵卡C到期提醒"></el-option>
            <el-option label="尊贵卡B到期休眠" value="尊贵卡B到期休眠"></el-option>
            <el-option label="尊贵卡C到期休眠" value="尊贵卡C到期休眠"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="alertList" stripe>
        <el-table-column type="index" label="序号" width="60" align="center" :index="indexMethod"></el-table-column>
        <el-table-column prop="customerName" label="客户" width="130"></el-table-column>
        <el-table-column label="负责人" width="120" align="center">
          <template slot-scope="scope">{{ scope.row.responsiblePerson || customerMap[scope.row.customerId] || '-' }}</template>
        </el-table-column>
        <el-table-column prop="alertType" label="提示类型" width="220" show-overflow-tooltip></el-table-column>
        <el-table-column label="等级" width="80">
          <template slot-scope="scope">
            <el-tag :type="levelType(scope.row.alertLevel)" size="mini">{{ scope.row.alertLevel }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="到期/截止时间" width="140" align="center">
          <template slot-scope="scope">{{ extractDueDate(scope.row) }}</template>
        </el-table-column>
        <el-table-column prop="content" label="提示内容" show-overflow-tooltip></el-table-column>
        <el-table-column prop="alertTime" label="计算时间" width="170">
          <template slot-scope="scope">{{ formatTime(scope.row.alertTime) }}</template>
        </el-table-column>
        <el-table-column v-if="$hasPerm('func:customer-alert:unfreeze')" label="操作" width="140" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button
              v-if="isVipAAlert(scope.row)"
              type="text"
              size="small"
              style="color: #67C23A; font-weight: bold;"
              icon="el-icon-unlock"
              @click="handleUnfreezeVipA(scope.row)">解禁</el-button>
            <span v-else style="color:#C0C4CC;font-size:12px;">-</span>
          </template>
        </el-table-column>
      </el-table>

      <div class="mt-4">
        <el-pagination
          @size-change="s => { pageSize = s; getAlertList() }"
          @current-change="p => { currentPage = p; getAlertList() }"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next"
          :total="total">
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import axios from 'axios'
import { alertApi } from '../api/api'

export default {
  data() {
    return {
      alertList: [],
      customerMap: {},
      searchForm: { customerName: '', alertType: '' },
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  mounted() {
    this.loadCustomers()
    this.getAlertList()
  },
  // keep-alive 缓存的页面，再次切回时也自动刷新
  activated() {
    this.loadCustomers()
    this.getAlertList()
  },
  methods: {
    loadCustomers() {
      axios.get('/customer/list').then(res => {
        const map = {}
        ;(res.data || []).forEach(c => {
          if (c.id) map[c.id] = c.responsiblePerson || '-'
        })
        this.customerMap = map
      }).catch(() => {})
    },
    getAlertList() {
      const me = (function () { try { return JSON.parse(sessionStorage.getItem('user') || '{}') } catch (e) { return {} } })()
      const isSuper = me && (me.role === 'super_admin' || me.role === '超级管理员' || Number(me.roleId) === 1)
      const isAdmin = me && !isSuper && (me.role === 'admin' || Number(me.roleId) === 2)
      const isSales = me && !isSuper && !isAdmin && Number(me.roleId) === 3
      // 超管/admin/业务员/输入客户姓名/输入提示类型 时：拉全量，前端过滤+分页，total 跟实际显示一致
      const kwForPull = (this.searchForm.customerName || '').trim()
      const typeForPull = (this.searchForm.alertType || '').trim()
      const pullAll = isSuper || isAdmin || isSales || !!kwForPull || !!typeForPull
      const pullPage = pullAll ? 1 : this.currentPage
      const pullSize = pullAll ? 10000 : this.pageSize
      const params = {
        alertType: pullAll ? undefined : (this.searchForm.alertType || undefined),
        // 行政管理员仅看自己客户的提示（自己客户 = responsiblePerson=自己 ∪ approverId=自己 关联的客户）
        mineForUserId: (isAdmin && me.id) ? me.id : undefined,
        // 业务员仅看自己客户的提示（我负责 ∪ 我建 ∪ 我提交过出库）
        salesmanUserId: (isSales && me.id) ? me.id : undefined
      }
      const kw = (this.searchForm.customerName || '').trim()
      const typeKw = (this.searchForm.alertType || '').trim()
      alertApi.getAlertPage(pullPage, pullSize, params).then(res => {
        let records = res.data.records || []
        // 后台客户提示统一只显示「到期相关」(到期提醒/到期休眠/服务费到期)，自然排除库存不足/禁售；禁售看「禁售名单」
        records = records.filter(a => {
          const t = a.alertType || ''
          return t.indexOf('到期提醒') !== -1
              || t.indexOf('到期休眠') !== -1
              || t.indexOf('服务费到期') !== -1
        })
        if (typeKw) {
          records = records.filter(a => this.matchAlertType(a.alertType, typeKw))
        }
        if (kw) {
          records = records.filter(a => (a.customerName || '').indexOf(kw) !== -1)
        }
        if (isSuper || isAdmin || isSales || kw || typeKw) {
          this.total = records.length
          const start = (this.currentPage - 1) * this.pageSize
          this.alertList = records.slice(start, start + this.pageSize)
        } else {
          this.alertList = records
          this.total = res.data.total || 0
        }
      })
    },
    matchAlertType(alertType, searchKw) {
      if (!searchKw || !searchKw.trim()) return true
      if (!alertType) return false
      const t = String(alertType).trim()
      const kw = String(searchKw).trim()
      if (t.indexOf(kw) !== -1) return true

      const kwHasA = kw.indexOf('尊贵卡A') !== -1 || kw.indexOf('卡A') !== -1 || kw.indexOf('A') !== -1
      const kwHasB = kw.indexOf('尊贵卡B') !== -1 || kw.indexOf('卡B') !== -1 || kw.indexOf('B') !== -1
      const kwHasC = kw.indexOf('尊贵卡C') !== -1 || kw.indexOf('卡C') !== -1 || kw.indexOf('C') !== -1

      if (kwHasA && (t.indexOf('尊贵卡A') === -1 && t.indexOf('卡A') === -1 && t.indexOf('A') === -1)) return false
      if (kwHasB && (t.indexOf('尊贵卡B') === -1 && t.indexOf('卡B') === -1 && t.indexOf('B') === -1)) return false
      if (kwHasC && (t.indexOf('尊贵卡C') === -1 && t.indexOf('卡C') === -1 && t.indexOf('C') === -1)) return false

      const kwHasAlert = kw.indexOf('提醒') !== -1
      const kwHasDormant = kw.indexOf('休眠') !== -1

      if (kwHasAlert && t.indexOf('提醒') === -1) return false
      if (kwHasDormant && t.indexOf('休眠') === -1) return false

      return true
    },
    handleSearch() {
      this.currentPage = 1
      this.getAlertList()
    },
    // 倒序序号：第一行 = 总条数，最后一行 = 1
    indexMethod(i) {
      return this.total - ((this.currentPage - 1) * this.pageSize + i)
    },
    levelType(level) {
      if (level === '高') return 'danger'
      if (level === '中') return 'warning'
      return 'info'
    },
    formatTime(t) {
      if (!t) return ''
      return String(t).replace('T', ' ').slice(0, 10)
    },
    extractDueDate(row) {
      if (!row || !row.content) return '-'
      const m = String(row.content).match(/(\d{4}-\d{2}-\d{2})/g)
      return (m && m.length) ? m[m.length - 1] : '-'
    },
    isVipAAlert(row) {
      if (!row || !row.alertType) return false
      return String(row.alertType).indexOf('尊贵卡A') !== -1
    },
    handleUnfreezeVipA(row) {
      this.$confirm(`确认解除客户【${row.customerName || ''}】的尊贵卡A休眠/缓冲期吗？<br/><span style="color:#909399;font-size:12px;">解禁后将恢复激活状态，提货周期重新计算。</span>`, '解禁确认', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定解禁',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        alertApi.unfreezeVipA({ alertId: row.id, customerId: row.customerId }).then(res => {
          if (res.data && res.data.success) {
            this.$message.success(res.data.message || '解禁成功！')
            this.getAlertList()
          } else {
            this.$message.error((res.data && res.data.message) || '解禁失败')
          }
        }).catch(err => {
          this.$message.error((err.response && err.response.data && err.response.data.message) || '网络或权限错误')
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.mb-4 { margin-bottom: 16px; }
.mt-4 { margin-top: 16px; }
.hint { color: #506580; font-size: 14px; margin-bottom: 12px; background: #E3F2FD; padding: 10px 14px; border-radius: 6px; border-left: 4px solid #2793FF; }
</style>
